<div class="panel-heading" style="color:#ffffff;background-color: #354D6A;" title="STAFF MAINTENANCE">
  <div class="page-titleheader">
    STAFF MAINTENANCE
  </div>
</div>
<br>
<div class="row"
  style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
  <div class="td-col-md-2" style="width: 20%; padding-left: 20px;" class="mobileview"></div>
  <div class="card mobileviewmain" style="width: 60%; border-style: solid;border-color: #11263f;">
    <div class="card-header">
      <div class="panel-heading" style="color:#ffffff;background-color: #11263f;" title="STAFF MAINTENANCE">
        <div class="page-titlehead">
          STAFF MAINTENANCE
        </div>
      </div>

    </div>

    <div>
      &nbsp;
      <div class="col-md-12 ">
        <button style="background-color:#11263f;text-align:left;border-color:white !important;" class="btn btn-info"
          tabindex="0" (click)="AddNewStaff()">
          <font color="white"> Add New Staff Member</font>
        </button>
        <div class="align">
          <button id="btnSave" style="background-color:#11263f;border-color:white !important" type="submit"
            class="btn btn-info" tabindex="0" title="Back to Dashboard" aria-label="Back to Dashboard"
            (click)="GoBacktoDashboard();">Back to Dashboard</button>&nbsp;
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <form class="form-horizontal">
            <div class="business-container">
              <mat-table [dataSource]="UsersdataSource" matSort>
                <ng-container matColumnDef="LastName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Staff name"> Staff Name
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" tabindex="0">
                    <span class="mobile-label">Staff Name:</span> {{element.FirstName}} {{element.LastName}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Username">
                  <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Staff Email">Staff Email
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" tabindex="0">
                    <span class="mobile-label">Staff Email:</span> {{element.Username}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="RoleName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Staff Group">Staff Group
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" tabindex="0">
                    <span class="mobile-label">Staff Group:</span> {{element.RoleName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Active">
                  <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Active Staff"> Active
                    Staff
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" tabindex="0">
                    <span class="mobile-label">Active Staff:</span> {{element.Active === 'True'?'Yes':'No'}}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Update">
                  <mat-header-cell *matHeaderCellDef> Update</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Update:</span>
                    <img style="cursor: pointer; color: #fff;" title="Update" tabindex="0"
                      (click)="UpdateStaffUser(element)" src="../assets/images/icon_edit.png">
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Delete">
                  <mat-header-cell *matHeaderCellDef> Delete</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Delete:</span>
                    <img style="cursor: pointer; color: #fff;" title="Delete" tabindex="0"
                      (click)="Deletestaffuser(element.Username)" src="../assets/images/delete_icon.png">
                  </mat-cell>
                </ng-container>


                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: getDisplayedColumns();"></mat-row>
              </mat-table>
              <mat-paginator [pageSizeOptions]="[10,20,50,100]" [pageSize]="10" showFirstLastButtons>
              </mat-paginator>
            </div>
          </form>


        </div>
      </div>
      <br>

    </div>
  </div>
</div>
<br>
